import React from "react";
import "./education.style.sass";
import TopOfNav from "../../layouts/topOfNav/topOfNav.component";
import StickyNav from "../../layouts/stickyNav/stickyNav.component";
import DrawerNav from "../../components/drawer/drawer.component";
import NavBar from "../../layouts/navbar/navbar.component";
import Footer from "../../layouts/footer/footer.component";
import EducationLayout from "../../layouts/education/education.layout";

const EducationPage = () => {
	if (window.location.href.indexOf("/q") >= 0) {
		window.location.replace("education");
	}

	return (
		<div>
			<TopOfNav />
			<StickyNav />
			<DrawerNav />
			<NavBar />
			<EducationLayout />
			<Footer />
		</div>
	);
};

export default EducationPage;
